export const baseRecordPic = require('./../assets/images/baserecord.png')
export const baseMusicPic = require('./../assets/images/basemusic.png')
